'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _align = require('./align');

Object.defineProperty(exports, 'align', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_align).default;
  }
});

var _width = require('./width');

Object.defineProperty(exports, 'width', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_width).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/flexomatic/lib/utils/index.js
// module id = 300
// module chunks = 4